const cardOne = {
  title: (
    <>
      We save,
      <br />
      not sting
    </>
  ),
  subtitle: 'Loan options with no fees, no loyalty tax and a rate you can drop.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-sleepsoundly-lg.jpg)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-sleepsoundly-modal-lg.jpg',
    mobile: '/next-assets/carousel/cvp-sleepsoundly-modal-sm.jpg',
  },
  modalContent: [
    {
      heading: 'Drop your own rate',
      paragraph: (
        <>
          With AcceleRATES, we&apos;ll drop your rate as you pay down your Straight Up or Power Up home loan
          <sup>2</sup>.
        </>
      ),
    },
    {
      heading: 'Loyalty is royalty',
      paragraph: (
        <>
          We always give existing and new customers the same awesome rates for like-for-like
          <sup>3</sup> loans with our Automatic Rate Match.
        </>
      ),
    },
    {
      heading: 'No Athena fees',
      paragraph: (
        <>
          Our Straight Up and Power Up loans have zero Athena fees
          <sup>1</sup>!
        </>
      ),
    },
  ],
};

const cardTwo = {
  title: (
    <>
      Apply in
      <br />
      minutes
    </>
  ),
  subtitle: 'With helpful humans at the ready.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-congrats-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-congrats-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-congrats-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'Speed',
      paragraph: "We'll get you a super-fast refi so you can  achieve your goals sooner.",
    },
    {
      heading: 'Ease',
      paragraph: 'Apply online in 15 minutes and get a decision in seconds.',
    },
    {
      heading: 'Expertise',
      paragraph: 'Talk to or text our Home Loan Experts. They can even put in your application for you!',
    },
  ],
};

const cardThree = {
  title: (
    <>
      Unlock
      <br />
      more equity
    </>
  ),
  subtitle: "We'll help you max your borrowing power.",
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-borrow-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-borrow-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-borrow-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'More power to you',
      paragraph: 'Our policies are far friendlier so you can borrow more.',
    },
    {
      heading: 'Leverage your home',
      paragraph: 'Put the extra $$$ towards renos or another property.',
    },
    {
      heading: 'At your fingertips',
      paragraph: 'Calculate what you can borrow in just 3 minutes!',
    },
  ],
};

const cardFour = {
  title: (
    <>
      Flexibility
      <br />
      without fees
    </>
  ),
  subtitle: 'Make loan changes when life changes.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-quote-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-quote-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-quote-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'Fee-free variations',
      paragraph:
        "Don't get charged when life changes. All changes to your Straight Up and Power Up loans are fee-free.",
    },
    {
      heading: 'Flexible cash-out',
      paragraph: 'Access equity and cash-out easily and quickly through our fast assessment process.',
    },
    {
      heading: 'Cashflow solutions',
      paragraph: 'Solve your cashflow crunch with debt consolidation, easy cash-out or interest only.',
    },
  ],
};

export const carouselCardContent = [cardOne, cardTwo, cardThree, cardFour];
